import ApiService from '@/common/api.service'
import JwtService from '@/common/jwt.service'
import {
    LOGIN,
    LOGOUT,
    RECOVERY,
    CHECK_AUTH,
    CHANGE_PASSWORD,
    VERIFY_TOKEN
} from '../actions.type'
import {
    SET_AUTH,
    PURGE_AUTH,
    SET_ERROR
} from '../mutations.type'

const state = {
    errors: {
        LOGIN: null,
        RECOVERY: null,
        CHECK: null,
        CHANGE: null
    },
    user: {},
    firstLogin: false,
    isAuthenticated: !!JwtService.getToken()
}

const getters = {
    currentUser (state) {
        return state.user
    },
    isAuthenticated (state) {
        return state.isAuthenticated
    },
    isFirstLogin (state) {
        return state.firstLogin
    }
}

const actions = {
    [LOGIN] (context, credentials) {
        return new Promise((resolve, reject) => {
            ApiService
                .post('auth', {
                    user: credentials
                })
                .then(({
                    data
                }) => {
                    context.commit(SET_AUTH, data.user)
                    resolve(data)
                })
                .catch(({
                    response
                }) => {
                    context.commit(SET_ERROR, {
                        type: 'LOGIN',
                        data: response.data.errors
                    })
                    reject(response)
                })
        })
    },
    [RECOVERY] (context, credentials) {
        return new Promise((resolve, reject) => {
            ApiService
                .post('users/recovery', {
                    user: credentials
                })
                .then(({
                    data
                }) => {
                    // context.commit(SET_AUTH, data.user)
                    resolve(data)
                })
                .catch(({
                    response
                }) => {
                    context.commit(SET_ERROR, {
                        type: 'RECOVERY',
                        data: response.data.errors
                    })
                    reject(response)
                })
        })
    },
    [LOGOUT] (context) {
        context.commit(PURGE_AUTH)
    },
    [CHECK_AUTH] (context) {
        if (JwtService.getToken()) {
            ApiService.setHeader()
            ApiService
                .get('user')
                .then(({
                    data
                }) => {
                    context.commit(SET_AUTH, data.user)
                })
                .catch(({
                    response
                }) => {
                    context.commit(SET_ERROR, {
                        type: 'CHECK',
                        data: response.data.errors
                    })
                })
        } else {
            context.commit(PURGE_AUTH)
        }
    },
    [CHANGE_PASSWORD] (context, passwords) {
        return new Promise((resolve) => {
            ApiService
                .post('password-change', {
                    password: passwords
                })
                .then((
                    data
                ) => {
                    resolve(data)
                })
                .catch(({
                    response
                }) => {
                    context.commit(SET_ERROR, {
                        type: 'CHANGE',
                        data: response.data.errors
                    })
                })
        })
    },
    [VERIFY_TOKEN] (context, token) {
        return new Promise((resolve, reject) => {
            ApiService
                .post('verify-login', {
                    token: token
                })
                .then(({
                    data
                }) => {
                    if ( data.user ) {
                        context.commit(SET_AUTH, data.user)
                        resolve(data)
                    }
                })
                .catch(({
                    response
                }) => {
                    reject(response)
                })
        })
    }
}

const mutations = {
    [SET_ERROR] (state, payload) {
        state.errors[payload.type] = { ...state.errors[payload.type], ...payload.data }
        // state.errors[payload.type] = Object.assign({}, state.errors[payload.type], payload.data)
        // console.log(state.errors)
    },
    [SET_AUTH] (state, user) {
        state.isAuthenticated = true
        state.user = user
        state.firstLogin = user.firstLogin
        state.errors = {}
        JwtService.saveToken(state.user.token)
    },
    [PURGE_AUTH] (state) {
        state.isAuthenticated = false
        state.firstLogin = true
        state.user = {}
        state.errors = {}
        JwtService.destroyToken()
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}
